import * as stdef from '../Defs/statusdefs'

export const updateStatus = (status, source = "application") => ({
    type: stdef.UPDATE_STATUS,
    payload: { status, source },
  });
